/**
 * HOOK: useDiscountsSelect
 * Hook léger pour charger uniquement les remises nécessaires aux selects
 *
 * ⚡ Optimisation: Ne charge que id, name, amount
 */

import { useSelectData } from './useSelectData';

interface DiscountSelectItem {
  id: string;
  name: string;
  amount: number;
}

interface UseDiscountsSelectReturn {
  discounts: DiscountSelectItem[];
  loading: boolean;
  error: Error | null;
  refresh: () => Promise<void>;
}

export function useDiscountsSelect(): UseDiscountsSelectReturn {
  const { data, loading, error, refresh } = useSelectData(
    'discounts',
    'id, name, amount',
    'name',
    true
  );

  return {
    discounts: data as DiscountSelectItem[],
    loading,
    error,
    refresh,
  };
}
